// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fa-chevron-left[data-v-ac56f6c4]:before,.fa-chevron-right[data-v-ac56f6c4]:before{color:#ccc}.container_icon[data-v-ac56f6c4]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.component-icone[data-v-ac56f6c4]{border:1px solid #ccc;width:50px;height:50px;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
